var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"width":"18","height":"18","rx":"4"}}),_c('path',{attrs:{"d":"M7 13.1V5L12.4 9.05L7 13.1Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }